<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition,
  },
};
</script>
<style>
@font-face {
  font-family: "iranyekan";
  src: url("../src/assets/fonts/iranyekan/iranyekanwebbold.ttf");
  src: url("../src/assets/fonts/iranyekan/iranyekanweblight.ttf");
  src: url("../src/assets/fonts/iranyekan/iranyekanwebregular.ttf");
  src: url("../src/assets/fonts/iranyekan/IRANYekanLightMobile(FaNum).ttf");
  src: url("../src/assets/fonts/iranyekan/IRANYekanMobileBold(FaNum).ttf");
  src: url("../src/assets/fonts/iranyekan/IRANYekanRegularMobile(FaNum).ttf");
}

* {
  font-family: "iranyekan";
}
</style>
